import * as yup from 'yup';
import { FormInputMeta } from "@Modules/core/types/FormMetaType";
import { getValidationSchema } from '@Shared/utils/validationSchema';

export interface IBankCalendarFormMeta {
  bank: FormInputMeta,
  year: FormInputMeta,
  monday: FormInputMeta,
  tuesday: FormInputMeta,
  wednesday: FormInputMeta,
  thursday: FormInputMeta,
  friday: FormInputMeta,
  satuday: FormInputMeta,
  sunday: FormInputMeta,

  // Schema
  schema: any,
}

const BankCalendarFormMeta: IBankCalendarFormMeta = {} as IBankCalendarFormMeta

BankCalendarFormMeta.bank = {
  name: 'bank',
  type: 'select',
  label: 'Banque',
  // placeholder: 'Banque',
  options: [
    {
      label: 'UBA',
      value: 'uba',
    }
  ],
  validation: yup.string().required(),
};

BankCalendarFormMeta.year = {
  name: 'year',
  type: 'select',
  label: 'Année',
  // placeholder: 'Année',
  options: [
    {
      label: '2023',
      value: '2023',
    }
  ],
  validation: yup.string().required(),
};

BankCalendarFormMeta.monday = {
  name: 'monday',
  type: 'checkbox',
  label: 'Lundi',
  validation: yup.string().required(),
};

BankCalendarFormMeta.tuesday = {
  name: 'tursday',
  type: 'checkbox',
  label: 'Mardi',
  validation: yup.string().required(),
};

BankCalendarFormMeta.wednesday = {
  name: 'wednesday',
  type: 'checkbox',
  label: 'Mercredi',
  validation: yup.string().required(),
};

BankCalendarFormMeta.thursday = {
  name: 'thursday',
  type: 'checkbox',
  label: 'Jeudi',
  validation: yup.string().required(),
};

BankCalendarFormMeta.friday = {
  name: 'friday',
  type: 'checkbox',
  label: 'Vendredi',
  validation: yup.string().required(),
};

BankCalendarFormMeta.satuday = {
  name: 'satuday',
  type: 'checkbox',
  label: 'Samedi',
  validation: yup.string().required(),
};

BankCalendarFormMeta.sunday = {
  name: 'sunday',
  type: 'checkbox',
  label: 'Dimanche',
  validation: yup.string().required(),
};


const validationSchema = getValidationSchema(BankCalendarFormMeta)
BankCalendarFormMeta.schema = yup.object().shape(validationSchema);

export default BankCalendarFormMeta;